import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'workflow-result',
	templateUrl: './result.component.html',
	styleUrls: ['./result.component.less']
})
export class ResultComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}
